<template>
  <div
    v-if="enabled"
    class="b-top b-bottom py-2 d-flex justify-space-between my-2 align-center font-size-regular"
  >
    <img
      class="mm-icon img-fluid flex-grow-1 mr-2"
      src="@/assets/images/miles-more-logo.svg"
      alt="Partner of Miles &amp; More"
      width="100"
      height="25"
    />
    <div class="d-flex flex-column c-gray">
      <div class="d-flex justify-end align-center">
        <span class="pr-1"
          >{{ translate('pdp_miles_and_more_banner_earn') }}:
        </span>
        <div class="d-flex align-center" :loading="earn < 0">
          {{ earn }}
          <SvgWrapper
            use="icon_svg_mam_filled"
            class="f-gray pr-1 ml-1"
            dimensions="20"
          />
          <TheMenu
            :title="translate('pdp_miles_and_more_banner_popup_earn_title')"
          >
            <template v-slot:activator="{ props }">
              <span
                v-bind="props"
                class="mm-info-button pr-1 d-inline-flex align-center cursor-pointer"
              >
                <SvgWrapper
                  class="f-gray"
                  use="icon_svg_info_filled"
                  dimensions="15"
                />
              </span>
            </template>
            <div
              class="v-col-12 text-center l-spacing-half l-height-25 pb-3 mm-description"
              v-html="popupEarnDescription"
            ></div>
          </TheMenu>
        </div>
      </div>
      <div class="d-flex justify-end align-center">
        <span class="pr-1"
          >{{ translate('pdp_miles_and_more_banner_spend') }}:
        </span>
        <div class="d-flex align-center" :loading="spend < 1">
          {{ spend }}
          <SvgWrapper
            use="icon_svg_mam_filled"
            class="f-gray pr-1 ml-1"
            dimensions="20"
          />
          <TheMenu
            :title="translate('pdp_miles_and_more_banner_popup_spend_title')"
          >
            <template v-slot:activator="{ props }">
              <span
                v-bind="props"
                class="mm-info-button pr-1 d-inline-flex align-center cursor-pointer"
              >
                <SvgWrapper
                  class="f-gray"
                  use="icon_svg_info_filled"
                  dimensions="15"
                />
              </span>
            </template>
            <div
              class="v-col-12 text-center l-spacing-half l-height-25 pb-3 mm-description"
              v-html="popupSpendDescription"
            ></div>
          </TheMenu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)
const TheMenu = defineAsyncComponent(
  () => import('@/components/basic/organisms/TheMenu.vue')
)

const LINK = 'https://vicampo.dixa.help/de/article/60c295'

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const [
      {
        default: { siteId }
      },
      { default: CookieHelper },
      { COOKIES }
    ] = await Promise.all([
      await import('@/services/SiteConfig'),
      await import('@/services/helpers/CookieHelper'),
      await import('@/constants/GlobalConstants')
    ])
    cache = { siteId, CookieHelper, COOKIES }
    return cache
  }
})()

export default {
  components: { TheMenu, SvgWrapper },
  props: {
    earn: [Number, String],
    spend: [Number, String],
    useCartTranslations: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enabled: false,
      anchor: null,
      hashes: {
        earn: null,
        spend: null
      }
    }
  },
  computed: {
    popupEarnDescription() {
      return this.translate(
        this.useCartTranslations
          ? 'new_cart_page_miles_earn'
          : 'pdp_miles_and_more_banner_popup_earn_info',
        this.earn
      )
    },
    popupSpendDescription() {
      return (
        this.translate(
          this.useCartTranslations
            ? 'new_cart_page_miles_spend'
            : 'pdp_miles_and_more_banner_popup_spend_info',
          this.spend
        ) + this.anchor
      )
    }
  },
  async created() {
    const { CookieHelper, COOKIES } = await _getModules()

    const link = this.translate(
      'pdp_miles_and_more_banner_popup_spend_more_info'
    )
    this.anchor = ` <a class="link-winered" href="${LINK}">${link}</a>`
    this.enabled = CookieHelper.getCookie(COOKIES.MILES_AND_MORE_ENABLED)
  }
}
</script>

<style scoped>
.mm-info-button {
  pointer-events: all;
}
.mm-icon {
  max-width: 100px;
  max-height: 34px;
}
.b-top {
  border-top: 1px solid rgb(var(--v-theme-cement-gray));
}
.b-bottom {
  border-bottom: 1px solid rgb(var(--v-theme-cement-gray));
}
</style>
